export const marksheetVerificationApis = {
    getMarksheetList: "v1/api/marksheetVerification",
    createMarksheet: "v1/api/marksheetVerification",
    getMarksheetbyId: "v1/api/marksheetVerification/getById?id=",
    updateMarksheetById: "v1/api/marksheetVerification?marksheetId=:marksheetId",
    deleteMarksheetbyId: "v1/api/marksheetVerification?marksheetId=:marksheetId",
    marksheetUpload: 'v1/api/adminDocumentUpload',
    getMarksheetUploadedDoc: 'v1/api/adminDocumentUpload?referanceId='
}

export const previousQualificationApis = {
    getQualificationList: "v1/api/studentPreviousQualification",
    createQualification: "v1/api/studentPreviousQualification",
    getQualificationbyId: "v1/api/studentPreviousQualification/:studentPreviousQualificationId",
    updateQualificationById: "v1/api/studentPreviousQualification?studentPreviousQualificationId=:studentPreviousQualificationId",
    deleteQualificationbyId: "v1/api/studentPreviousQualification?studentPreviousQualificationId=:studentPreviousQualificationId",
}
